// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3yIxX","colMin":"styles_colMin__BNUD_","colCheckbox":"styles_colCheckbox__2ILLR"};